var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCogWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.99 14C12.6468 14 13.99 12.6569 13.99 11C13.99 9.34315 12.6468 8 10.99 8C9.33314 8 7.98999 9.34315 7.98999 11C7.98999 12.6569 9.33314 14 10.99 14Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.98999 11.8801V10.1201C0.98999 9.08006 1.83999 8.22006 2.88999 8.22006C4.69999 8.22006 5.43999 6.94006 4.52999 5.37006C4.00999 4.47006 4.31999 3.30006 5.22999 2.78006L6.95999 1.79006C7.74999 1.32006 8.76999 1.60006 9.23999 2.39006L9.34999 2.58006C10.25 4.15006 11.73 4.15006 12.64 2.58006L12.75 2.39006C13.22 1.60006 14.24 1.32006 15.03 1.79006L16.76 2.78006C17.67 3.30006 17.98 4.47006 17.46 5.37006C16.55 6.94006 17.29 8.22006 19.1 8.22006C20.14 8.22006 21 9.07006 21 10.1201V11.8801C21 12.9201 20.15 13.7801 19.1 13.7801C17.29 13.7801 16.55 15.0601 17.46 16.6301C17.98 17.5401 17.67 18.7001 16.76 19.2201L15.03 20.2101C14.24 20.6801 13.22 20.4001 12.75 19.6101L12.64 19.4201C11.74 17.8501 10.26 17.8501 9.34999 19.4201L9.23999 19.6101C8.76999 20.4001 7.74999 20.6801 6.95999 20.2101L5.22999 19.2201C4.31999 18.7001 4.00999 17.5301 4.52999 16.6301C5.43999 15.0601 4.69999 13.7801 2.88999 13.7801C1.83999 13.7801 0.98999 12.9201 0.98999 11.8801Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCogWheel);
export default __webpack_public_path__ + "static/media/cog-wheel.b699e64b2bc0cca0ce4b967011186f29.svg";
export { ForwardRef as ReactComponent };